/**
 * Mime Interceptor.
 */

module.exports = function (_) {

    return {

        request: function (request) {

            if (request.emulateJSON && _.isPlainObject(request.data)) {
                request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                request.data = _.url.params(request.data);
            }

            if (_.isObject(request.data) && /FormData/i.test(request.data.toString())) {
                delete request.headers['Content-Type'];
            }

            if (_.isPlainObject(request.data)) {
                request.data = JSON.stringify(request.data);
            }

            return request;
        },

        response: function (response) {

            try {
                response.data = JSON.parse(response.data);
            } catch (e) {}

            return response;
        }

    };

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/interceptor/mime.js
// module id = 227
// module chunks = 1